export enum EOriginePrescription {
	medTraitant = "T",
	medCorrespondant = "O",
	autreSituationParcours = "P",
	horsParcoursDeSoin = "S",
	renouvellementAdapte = "A",
	renouvellementIdentique = "I"
}
